import React, { FunctionComponent } from 'react'
import iconThumbsUp from '../assets/images/icon-thumbs-up.png'
import { Link } from 'react-router-dom'

const ManualReviewRefiStatus: FunctionComponent<object> = ({}) => {
  return (
    <div className="status-view__main">
      <div className="status-view">
        <img
          className="status-view__img"
          src={iconThumbsUp}
          alt="Thumbs up icon"
        />
        <div className="status-view__container">
          <h2 className="status-view__title">
            Your application is being reviewed
          </h2>
          <p>
            Please inform the consumer that their application is being reviewed
            by the under writing team and that we will reach out to them
            shortly. Please check back soon, this typically takes about 30
            minutes during normal business hours.
          </p>
          <Link to="/" replace className="status-view__button-container">
            <button className="button">OK</button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ManualReviewRefiStatus
